import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4.4 12a.6.6 0 0 1 .6-.6h14a.6.6 0 1 1 0 1.2H5a.6.6 0 0 1-.6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
